/** @file This file contains paginated response types. */
/**
 * Creates a function that processes a Response object using a specified parser function,
 * and then constructs a result object using a provided configuration function.
 *
 * @param parser Function to parse the response into a desired format.
 * @returns A function that takes a Response and returns a Promise resolving to an ApiResult.
 */
export function makeResult(parser) {
    return async (response) => ({
        type: 'cursor',
        data: await parser(response),
        nextToken: response.headers.get('Next-Token') ?? undefined,
    });
}
